import React from "react";

export const STATUS_STYLES = {
    Open: { bg: "#eaf3ff", fg: "#11407c", dot: "#2e6dd6" },
    "Under Review": { bg: "#fff5e3", fg: "#8a560f", dot: "#d28321" },
    Quoted: { bg: "#e9f5ec", fg: "#1a5a2f", dot: "#2e8c4d" },
    Closed: { bg: "#eeeeee", fg: "#4a4a4a", dot: "#888888" },
};

const StatusBadge = ({ status, size = "md" }) => {
    const s = STATUS_STYLES[status] || STATUS_STYLES.Open;
    const pad = size === "sm" ? "px-2.5 py-1 text-[11px]" : "px-3 py-1.5 text-[12px]";
    return (
        <span
            className={`inline-flex items-center gap-2 font-body font-semibold uppercase tracking-[0.14em] ${pad}`}
            style={{ background: s.bg, color: s.fg }}
            data-testid={`status-${status.toLowerCase().replace(/\s+/g, "-")}`}
        >
            <span
                className="w-1.5 h-1.5 rounded-full"
                style={{ background: s.dot }}
            />
            {status}
        </span>
    );
};

export default StatusBadge;
